
export const currentEnvironment = () =>
  process.env.REACT_APP_STAGE || "production"